'use client'

import CardCarousel from '@/components/common/CardCarousel'
import { transformToListCards } from '@/lib/helpers/transformToListCard'
import { City, ThingsToDo } from '@/payload-types'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

const ActivityClient = ({ city, activities }: { city: City; activities: ThingsToDo[] }) => {
  const thingsToDo = useMemo(() => transformToListCards(activities, '/things-to-do'), [activities])

  const t = useTranslations()

  if (typeof city.country === 'number') return null

  return (
    <CardCarousel
      title={`${t('other_things_to_do_in')} ${city.title}`}
      items={thingsToDo}
      link={{
        pathname: `/hotels/[country]/[city]` as const,
        params: { country: city.country.slug as string, city: city.slug as string },
      }}
      linkTitle={`${t('explore')} ${city.title}`}
    />
  )
}

export default ActivityClient
